export const env =
  window.location.hostname.includes('localhost') ?
    import.meta.env.VITE_ENVIRONMENT
  : window.location.hostname.split('.')[1];
export const isPrd = env === 'prd';
export const isComm = env === 'comm';
export const isHil = env === 'hil';
